<template>
    <div class="app-title">
        <div>
            <h1>{{ name }}</h1>
            <p>Wanon Niwat Hospital [{{ app.name_en }}]</p>
        </div>
        <ul class="app-breadcrumb breadcrumb">
            <li class="breadcrumb-item"><i class="bi bi-house-door fs-6"></i></li>
            <li class="breadcrumb-item">
                <router-link :to="{ name: 'dashboard' }">หน้าหลัก</router-link>
            </li>
        </ul>
    </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
    props: {
        name: String
    },
    computed: mapState(['app']),
}
</script>

<style></style>